import { useEffect } from 'react';
import { useThrowAsyncErrorToBoundary } from './useThrowAsyncErrorToBoundary';
/**
 * A hook which takes a normal useEffect hook but transforms it to support a full asynchronous life cycle.
 */
export const useAsyncEffect = (fn, deps = []) => {
    const throwErrorToBoundary = useThrowAsyncErrorToBoundary();
    useEffect(() => {
        let isComponentMounted = true;
        let abortController = null;
        if (window.AbortController) {
            abortController = new AbortController();
        }
        const runIfMounted = (callback) => {
            if (!isComponentMounted) {
                return;
            }
            callback();
        };
        const runIfMountedThrowErrorToBoundary = (e) => {
            runIfMounted(() => throwErrorToBoundary(e));
        };
        const cleanup = fn({
            abortSignal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
            runIfMounted,
            isComponentMounted,
            throwErrorToBoundary: runIfMountedThrowErrorToBoundary,
        });
        return () => {
            abortController === null || abortController === void 0 ? void 0 : abortController.abort();
            isComponentMounted = false;
            if (cleanup) {
                cleanup();
            }
        };
    }, [...deps, throwErrorToBoundary]);
};
//# sourceMappingURL=useAsyncEffect.js.map